import React from 'react'
import { RichText } from 'prismic-reactjs'
import { linkResolver } from '../../prismic-configuration'
import { customLink } from '../../utils/prismicHelpers'

const RichTextField = ({ field, ...rest }) => {
  // ❌ pas un tableau → stop
  if (!Array.isArray(field)) return null

  // 🔥 nettoyage profond (clé du bug)
  const safeField = field
    .filter(block => block && typeof block === 'object')
    .map(block => ({
      ...block,
      text: block.text || '',
      spans: Array.isArray(block.spans) ? block.spans : []
    }))

  // vide → stop
  if (safeField.length === 0) return null

  return (
    <RichText
      {...rest}
      render={safeField}
      linkResolver={linkResolver}
      serializeHyperlink={customLink}
    />
  )
}

export default RichTextField